import React from 'react';
import './App.less';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { AuthProvider } from '@/utils/auth';
import '@/events/heartbeat';
import { AntdStatic } from '@/utils';

const App = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          borderRadius: 4,
        },
      }}
    >
      <AntdApp component={false}>
        <AntdStatic />
        <AuthProvider>
          <RouterProvider router={router}/>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

export default App;
